import type { BlogCategory } from "~/entities/blog/types";
import type { ProductPrice, ProductTile } from "~/entities/product/types";
import Categories from "./Categories";
import NewsletterSignup from "./NewsletterSignup";
import RelatedProducts from "./RelatedProducts";
import Search from "./Search";
import "./style.css";

type Props = {
  categories: BlogCategory[];
  query?: string;
  relatedProducts?: ProductTile[];
  relatedProductPrices?: Promise<ProductPrice[] | null>;
};

const BlogSidebar: React.FC<Props> = ({
  categories,
  query,
  relatedProducts = [],
  relatedProductPrices,
}) => (
  <aside className="blog-sidebar">
    <Search query={query} />
    <NewsletterSignup />
    <Categories categories={categories} />
    <RelatedProducts
      products={relatedProducts}
      prices={relatedProductPrices}
    />
  </aside>
);

export default BlogSidebar;
